/**
 * Honor milestone schemas.
 *
 * User achievements / journey milestones.
 */
import { z } from 'zod';

/** Internal: record a milestone (called by backend services). */
export const HonorMilestoneCreateSchema = z.object({
  user_id: z.number().int().positive(),
  milestone: z.string().min(1).max(64),
  title: z.string().min(1).max(200),
  description: z.string().max(500).optional(),
  value: z.string().max(128).optional(),
  badge: z.string().max(64).optional(),
});
export type HonorMilestoneCreateRequest = z.infer<typeof HonorMilestoneCreateSchema>;

/** GET /api/honor/milestones — user's own milestones. */
export const HonorMilestoneListQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(200).default(50),
  milestone: z.string().max(64).optional(),
});
export type HonorMilestoneListQuery = z.infer<typeof HonorMilestoneListQuerySchema>;

/** GET /api/admin/honor — admin list. */
export const HonorMilestoneAdminListQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(200).default(50),
  user_id: z.coerce.number().int().positive().optional(),
  milestone: z.string().max(64).optional(),
});
export type HonorMilestoneAdminListQuery = z.infer<typeof HonorMilestoneAdminListQuerySchema>;
